import React from "react";
import moment from "moment";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Label,
  FormGroup,
} from "reactstrap";
import { Upload, Icon, notification, message, Button, Input as In } from "antd";
import firebase from "../../../Firebase.js";
import "antd/dist/antd.css";
import {
  normalizeFiles,
  haySubidaEnCurso,
  urlDeItem,
  aFileList,
  aCampos,
} from "../../../utils/fileList";
import { propagarArchivosDeOp } from "services";

class DirectNewDdpRecord extends React.Component {
  constructor() {
    super();
    this.ref = firebase.firestore().collection("ddp");
    this.storageRef = firebase.storage();

    this.state = {
      fechaIngreso: new Date(),
      fechaIngresoV1: new Date(),
      isOpen: false,
      prof: "",
      selectedOption: null,
      ing: [],
      imgFT: null,
      imgHC: null,
      value: null,
      fichaTecnica: "",
      hojaConsumo: "",
      doc: "",
      ordenPedido: "",
      proforma: "",
      comercialValue: "",
      ingValue: "",
      telasValue: "",
      corteValue: "",
      costuraValue: "",
      acabadosValue: "",
      update: false,
      almacenValue: "",
      isActive: false,
      selectedFile: null,
      selectedFileList: [],
      filelistFT: null,
      fileListFT: null,
      filelistHC: [],
      filelistMoldes: [],
      filelistTizado: [],
      uploading: false,
      fichTec: [],
      hojaCon: [],
      moldesList: [],
    };
    this.changeHc = this.changeHc.bind(this);
    this.changeFt = this.changeFt.bind(this);
    this.changeMoldes = this.changeMoldes.bind(this);
  }

  componentDidMount() {
    const { doc, op } = this.props.location.state;
    const update = this.props.location.state.update;

    firebase
      .firestore()
      .collection("ddp")
      .orderBy("order", "asc")
      .get()
      .then((qs) => {
        const ftecnica = [];
        const hconsumo = [];
        const moldesArr = [];
        qs.forEach((doc) => {
          if (doc.data().fichaTecnica) {
            ftecnica.push(doc.data().fichaTecnica);
          }
          if (doc.data().hojaConsumo) {
            hconsumo.push(doc.data().hojaConsumo);
          }
          if (doc.data().moldes) {
            moldesArr.push(doc.data().moldes);
          }
        });
        this.setState({ fichTec: ftecnica, hojaCon: hconsumo, moldesList: moldesArr });
      });

    this.ref
      .doc(String(doc))
      .get()
      .then((idx) => {
        const dataDDP = idx.data();
        const fichaT = dataDDP.fichaTecnica;
        const urlFichaT = dataDDP.b ? dataDDP.b[0] : null;

        this.setState({
          fichaTecnica: fichaT,
          urlFichaT,
          fileListFT: urlFichaT
            ? [
                {
                  uid: doc,
                  name: fichaT,
                  status: "done",
                  url: urlFichaT,
                },
              ]
            : null,
          filelistHC: aFileList(
            normalizeFiles(dataDDP.hc, dataDDP.hojaConsumo)
          ),
          filelistMoldes: aFileList(
            normalizeFiles(dataDDP.moldesUrl, dataDDP.moldes)
          ),
          filelistTizado: aFileList(
            normalizeFiles(dataDDP.tizadoDdpUrl, dataDDP.tizadoDdp)
          ),
        });
      });

    this.setState({
      doc: doc,
      ordenPedido: op,
      update: update,
    });

    firebase
      .firestore()
      .collection("ing")
      .where("op", "==", op)
      .get()
      .then((querySnapshot) => {
        let ingValue;
        querySnapshot.forEach((doc) => {
          ingValue = doc.data().index;
        });
        this.setState({ ingValue });
      });
  }

  handleChange = (date) => {
    this.setState({
      fechaIngreso: date,
    });
  };

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };
  np;

  changeFt = (e) => {
    if (e.target.files[0]) {
      const imgFT = e.target.files[0];
      this.setState(() => ({ imgFT, fichaTecnica: imgFT.name.slice(0, -4) }));
    }
  };

  changeHc = (e) => {
    if (e.target.files[0]) {
      const imgHC = e.target.files[0];
      this.setState(() => ({ imgHC, hojaConsumo: imgHC.name.slice(0, -4) }));
    }
  };

  changeMoldes = (e) => {
    if (e.target.files[0]) {
      const imgMoldes = e.target.files[0];
      this.setState(() => ({ imgMoldes, moldes: imgMoldes.name.replace(/\.[^/.]+$/, "") }));
    }
  };

  handleChangeFT = (info) => {
    let fileListFT = [...info.fileList];

    fileListFT = fileListFT.slice(-1);

    fileListFT = fileListFT.map((file) => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });
    this.setState({ filelistFT: info.fileList, fileListFT });

    if (info.file.status === "uploding") {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === "done") {
      this.setState({ loading: false });
    }
  };

  customUploadFT = async ({ onError, onSuccess, file }) => {
    this.setState({ uploading: true });
    const metadata = {
      contentType: ".pdf",
    };
    const storager = await this.storageRef.ref();
    const pdfFile = storager.child(`fichaTecnica/${file.name}`);

    try {
      const pdf = await pdfFile.put(file, metadata);
      const url = await this.storageRef
        .ref("fichaTecnica")
        .child(file.name)
        .getDownloadURL();
      this.setState(() => ({
        file,
        fichaTecnica: file.name.slice(0, -4),
        uploading: false,
      }));
      onSuccess(null, { ...pdf, url });
    } catch (e) {
      this.setState({ uploading: false });
      onError(e.message);
    }
  };

  handleChangeHC = (info) => {
    this.setState({ filelistHC: info.fileList });
    this.setState({ loading: info.file.status === "uploading" });
  };

  customUploadHC = async ({ onError, onSuccess, file }) => {
    this.setState({ uploading: true });
    const storager = await this.storageRef.ref();
    const nombre = `${Date.now()}-${file.name}`;

    try {
      const pdf = await storager.child(`hojaConsumo/${nombre}`).put(file);
      const url = await this.storageRef
        .ref("hojaConsumo")
        .child(nombre)
        .getDownloadURL();
      this.setState({ uploading: false });
      onSuccess(null, { ...pdf, url });
    } catch (e) {
      this.setState({ uploading: false });
      onError(e.message);
    }
  };

  handleChangeMoldes = (info) => {
    this.setState({ filelistMoldes: info.fileList });
    this.setState({ loading: info.file.status === "uploading" });
  };

  customUploadMoldes = async ({ onError, onSuccess, file }) => {
    this.setState({ uploading: true });
    const storager = await this.storageRef.ref();
    const nombre = `${Date.now()}-${file.name}`;

    try {
      const pdf = await storager.child(`moldes/${nombre}`).put(file);
      const url = await this.storageRef
        .ref("moldes")
        .child(nombre)
        .getDownloadURL();
      this.setState({ uploading: false });
      onSuccess(null, { ...pdf, url });
    } catch (e) {
      this.setState({ uploading: false });
      onError(e.message);
    }
  };

  handleChangeTizado = (info) => {
    this.setState({ filelistTizado: info.fileList });
    this.setState({ loading: info.file.status === "uploading" });
  };

  customUploadTizado = async ({ onError, onSuccess, file }) => {
    this.setState({ uploading: true });
    const storager = await this.storageRef.ref();
    const nombre = `${Date.now()}-${file.name}`;

    try {
      const pdf = await storager.child(`tizadosDdp/${nombre}`).put(file);
      const url = await this.storageRef
        .ref("tizadosDdp")
        .child(nombre)
        .getDownloadURL();
      this.setState({ uploading: false });
      onSuccess(null, { ...pdf, url });
    } catch (e) {
      this.setState({ uploading: false });
      onError(e.message);
    }
  };

  onSubmit = async (e) => {
    e.preventDefault();

    const {
      urlFichaT,
      ingValue,
      fechaIngreso: fechaIngresoInput,
      fichaTecnica: fitec,
      doc,
      ordenPedido: op,
    } = this.state;

    this.setState({
      isActive: true,
    });
    const fechaIngreso = moment(fechaIngresoInput).format("DD/MM/YYYY");

    const fturl =
      (this.state.filelistFT && this.state.filelistFT.length
        ? urlDeItem(this.state.filelistFT[0])
        : null) || urlFichaT;

    const hcFiles = aCampos(this.state.filelistHC);
    const moldesFiles = aCampos(this.state.filelistMoldes);
    const tizadoFiles = aCampos(this.state.filelistTizado);
    const hojcon = hcFiles.map((f) => f.name).join(", ");
    const moldesName = moldesFiles.map((f) => f.name).join(", ");
    const tizadoName = tizadoFiles.map((f) => f.name).join(", ");

    message.loading("Registrando...", 60);
    try {
      try {
        firebase
          .firestore()
          .collection("comercial")
          .where("op", "==", op)
          .limit(1)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = {
                cFechaIngreso: fechaIngreso,
                fichaTecnica: fitec,
                f: [fturl],
              };
              try {
                firebase
                  .firestore()
                  .collection("comercial")
                  .doc(doc.id)
                  .update(data);
              } catch (e) {
                console.log(e.message);
              }
            });
          });
      } catch (error) {
        console.log(error.message);
      }

      try {
        firebase
          .firestore()
          .collection("ing")
          .doc(String(ingValue))
          .get()
          .then((res) => {
            let ing = res.data();
            if (fitec) {
              ing["fichaTecnica"] = fitec || "";
              ing.b = [fturl || ""];
            }
            try {
              firebase
                .firestore()
                .collection("ing")
                .doc(String(ingValue))
                .set(ing, { merge: true });
            } catch (error) {
              console.log("Error adding document: ", error);
              console.log(error.message);
              console.log(error);
            }
          });
      } catch (error) {
        console.log("Sucedio un error. Ingrese nuevamente el registro", error);
        console.log(error.message);
        console.log(error);
      }

      try {
        firebase
          .firestore()
          .collection("telas")
          .where("op", "==", op)
          .get()
          .then((querySnapshot) => {
            let telasDocId = null;
            querySnapshot.forEach((doc) => {
              telasDocId = doc.id;
              // Sin spread de doc.data(): update() con campos explicitos
              // evita revertir lo que escribe propagarArchivosDeOp.
              const telaData = {
                ft: fitec || "",
                b: fturl ? [fturl] : [],
              };

              try {
                firebase
                  .firestore()
                  .collection("telas")
                  .doc(telasDocId)
                  .update(telaData);
              } catch (error) {
                console.log(error.message);
              }
            });
          });
      } catch (error) {
        console.log(error.message);
      }

      try {
        firebase
          .firestore()
          .collection("corte")
          .where("op", "==", op)
          .get()
          .then((querySnapshot) => {
            let corteDocId = null;
            querySnapshot.forEach((doc) => {
              corteDocId = doc.id;
              // Sin spread, por la misma razon que en telas.
              const corteData = {
                ft: fitec || "",
                b: [fturl || ""],
              };
              firebase
                .firestore()
                .collection("corte")
                .doc(corteDocId)
                .update(corteData);
            });
          });
      } catch (error) {
        console.log(error.message);
      }

      try {
        firebase
          .firestore()
          .collection("costura")
          .where("op", "==", op)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const costuraData = {
                ft: fitec || "",
                b: [fturl || ""],
              };
              firebase
                .firestore()
                .collection("costura")
                .doc(doc.id)
                .update(costuraData);
            });
          });
      } catch (error) {
        console.error(error.message);
      }

      try {
        firebase
          .firestore()
          .collection("acabados")
          .where("op", "==", op)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const acabadosData = {
                ft: fitec || "",
                b: [fturl || ""],
              };
              firebase
                .firestore()
                .collection("acabados")
                .doc(doc.id)
                .update(acabadosData);
            });
          });
      } catch (error) {
        console.error(error.message);
      }

      try {
        firebase
          .firestore()
          .collection("almacen")
          .where("op", "==", op)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const almacenData = {
                ft: fitec || "",
                b: [fturl || ""],
              };

              firebase
                .firestore()
                .collection("almacen")
                .doc(doc.id)
                .update(almacenData);
            });
          });
      } catch (error) {
        console.error(error.message);
      }

      // hojaConsumo/hc/moldes/moldesUrl los escribe propagarArchivosDeOp,
      // que alcanza tambien a este documento de ddp.
      const data = {
        fechaIngresoDdp: fechaIngreso || "",
        fichaTecnica: fitec || "",
        b: [fturl || ""],
        estado: [fturl && hcFiles.length ? "Listo" : "En curso", op],
      };

      try {
        this.ref
          .doc(doc)
          .update(data)
          .then(() =>
            // El catch de abajo cubre toda la cadena; sin esto, un fallo del
            // update anterior se reportaria como fallo de propagacion.
            propagarArchivosDeOp(op, {
              hojaConsumo: hojcon,
              hc: hcFiles,
              moldes: moldesName,
              moldesUrl: moldesFiles,
              tizadoDdp: tizadoName,
              tizadoDdpUrl: tizadoFiles,
            }).catch((e) => {
              throw new Error(
                `No se pudo propagar los archivos: ${e.message}`
              );
            })
          )
          .then(() => {
            message.destroy();
            const args = {
              message: "Registro agregado existosamente.",
              top: 80,
            };
            notification.success(args);
            this.setState({
              isActive: false,
            });
            this.props.history.push("/Ddp/Procesos");
          })
          .catch((error) => {
            message.destroy();
            notification.error({ message: error.message, top: 80 });
            this.setState({ isActive: false });
          });
      } catch (error) {
        console.log(error.message);
      }
    } catch (error) {
      console.error(error.message);
    }
    //}
  };

  render() {
    const { fichaTecnica, ordenPedido, loading } = this.state;

    const tiene = (lista) => Boolean(lista && lista.length);
    const subiendo =
      this.state.uploading ||
      haySubidaEnCurso(
        this.state.filelistFT,
        this.state.filelistHC,
        this.state.filelistMoldes,
        this.state.filelistTizado
      );
    const isInvalid = !(
      fichaTecnica ||
      tiene(this.state.filelistHC) ||
      tiene(this.state.filelistMoldes) ||
      tiene(this.state.filelistTizado)
    );

    const uploadButton = (
      <div>
        <Button
          style={{ display: "block", textAlign: "left", marginLeft: "1px" }}
        >
          <Icon type={loading ? "loading" : "plus"} />
          Seleccionar Archivo
        </Button>
      </div>
    );

    return (
      <div className="content">
        <Row>
          <Col md={12} xs={12}>
            <Card className="card-user">
              <CardHeader>
                <CardTitle style={{ textAlign: "center" }}>
                  REGISTRO DDP
                </CardTitle>
              </CardHeader>
              <CardBody className="ml-3">
                <form>
                  <FormGroup>
                    <Label className="font-weight-bold">
                      ORDEN DE PRODUCCIÓN
                    </Label>
                    <In
                      className="col-md-3 d-block"
                      value={ordenPedido}
                      disabled
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="font-weight-bold">FICHA TECNICA</Label>
                    <In
                      name="ft"
                      className="col-md-3 d-block"
                      value={fichaTecnica}
                      onChange={this.onChange}
                      autoComplete="off"
                      disabled
                    />
                  </FormGroup>

                  <Row>
                    <Label
                      style={{ marginLeft: "15px", fontWeight: "bold" }}
                      className="font-weight-bold"
                    >
                      FICHA TECNICA
                    </Label>
                  </Row>
                  <Upload
                    onRemove={() =>
                      this.setState({ filelistFT: null, fichaTecnica: "" })
                    }
                    accept={".pdf"}
                    multiple={false}
                    onChange={this.handleChangeFT}
                    customRequest={this.customUploadFT}
                    fileList={this.state.fileListFT}
                    style={{ display: "block", textAlign: "left" }}
                  >
                    {uploadButton}
                  </Upload>

                  <Row>
                    <Label
                      style={{ marginLeft: "15px", fontWeight: "bold" }}
                      className="font-weight-bold mt-4"
                    >
                      HOJA DE CONSUMO
                    </Label>
                  </Row>
                  <Upload
                    onRemove={(file) =>
                      this.setState((prev) => ({
                        filelistHC: (prev.filelistHC || []).filter(
                          (f) => f.uid !== file.uid
                        ),
                      }))
                    }
                    accept={".pdf"}
                    multiple
                    onChange={this.handleChangeHC}
                    customRequest={this.customUploadHC}
                    fileList={this.state.filelistHC}
                    style={{ display: "block", textAlign: "left" }}
                  >
                    {uploadButton}
                  </Upload>

                  <Row>
                    <Label
                      style={{ marginLeft: "15px", fontWeight: "bold" }}
                      className="font-weight-bold mt-4"
                    >
                      MOLDES
                    </Label>
                  </Row>
                  <Upload
                    onRemove={(file) =>
                      this.setState((prev) => ({
                        filelistMoldes: (prev.filelistMoldes || []).filter(
                          (f) => f.uid !== file.uid
                        ),
                      }))
                    }
                    multiple
                    onChange={this.handleChangeMoldes}
                    customRequest={this.customUploadMoldes}
                    fileList={this.state.filelistMoldes}
                    style={{ display: "block", textAlign: "left" }}
                  >
                    {uploadButton}
                  </Upload>

                  <Row>
                    <Label
                      style={{ marginLeft: "15px", fontWeight: "bold" }}
                      className="font-weight-bold mt-4"
                    >
                      TIZADO DDP
                    </Label>
                  </Row>
                  <Upload
                    onRemove={(file) =>
                      this.setState((prev) => ({
                        filelistTizado: (prev.filelistTizado || []).filter(
                          (f) => f.uid !== file.uid
                        ),
                      }))
                    }
                    multiple
                    onChange={this.handleChangeTizado}
                    customRequest={this.customUploadTizado}
                    fileList={this.state.filelistTizado}
                    style={{ display: "block", textAlign: "left" }}
                  >
                    {uploadButton}
                  </Upload>
                  <Row>
                    <div className="update ml-auto mr-auto">
                      <Button
                        type="primary"
                        onClick={this.onSubmit}
                        disabled={
                          this.state.isActive ||
                          subiendo ||
                          isInvalid
                        }
                      >
                        Registrar
                      </Button>
                    </div>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default DirectNewDdpRecord;
